// Ionic
import { alertController } from '@ionic/vue';

// Vue
import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';

// メモった！、キニッタ！共通スクリプト
import * as GFunc from '@/components/00/Common00';  // 共通メソッド

const routes: Array<RouteRecordRaw> = [

  //
  // メモった！キニッタ！共通画面
  //
  {
    // アカウント新規作成ページ
    path: '/S00001001',
    name: 'S00001001',
    component: () => import('@/components/00/S00001001Page.vue')
  },
  {
    // アカウント新規作成ヘルプページ
    path: '/S00001001/help',
    name: 'S00001001help',
    component: () => import('@/components/00/S00001001Help_ja.vue')
  },
  {
    // アカウント作成確認ページ
    path: '/S00001002',
    name: 'S00001002',
    component: () => import('@/components/00/S00001002Page.vue')
  },
  {
    // プロフィール変更ページ
    path: '/S00001003',
    name: 'S00001003',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001003Page.vue')
  },
  {
    // パスワード変更ページ
    path: '/S00001004',
    name: 'S00001004',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001004Page.vue')
  },
  {
    // アカウント削除ページ
    path: '/S00001005',
    name: 'S00001005',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001005Page.vue')
  },
  {
    // お問い合わせページページ
    path: '/S00001006',
    name: 'S00001006',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001006Page.vue')
  },
  {
    // アカウント情報表示ページ
    path: '/S00001007',
    name: 'S00001007',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001007Page.vue')
  },
  {
    // ログアウトページ
    path: '/S00001008',
    name: 'S00001008',
    component: () => import('@/components/00/S00001008Page.vue')
  },
  {
    // お知らせ表示ページ
    path: '/S00001012',
    name: 'S00001012',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/components/00/S00001012Page.vue')
  },
  /*
  {
    // 入力項目選択ページ
    path: '/S00001014',
    name: 'S00001014',
    component: () => import('@/components/00/S00001014Page.vue')
  },
  */
  {
    // 地図全画面表示ページ(iOSのみ）
    path: '/S00001015',
    name: 'S00001015',
    component: () => import('@/components/00/S00001015Page.vue')
  },

  //
  // キニッタ！専用画面
  //
  {
    // ログインページを表示
    path: '/',
    component: () => import('@/views/05/S05002000Page.vue')
  },
  {
    // ログインページ
    path: '/S05002000',
    name: 'S05002000',
    component: () => import('@/views/05/S05002000Page.vue')
  },
  {
    // 店舗一覧ページ
    path: '/S05002001',
    name: 'S05002001',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002001Page.vue')
  },
  {
    // 店舗管理ページ
    path: '/S05002002',
    name: 'S05002002',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002002Page.vue')
  },
  {
    // 店舗情報編集ページ
    path: '/S05002003',
    name: 'S05002003',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002003Page.vue')
  },
  {
    // イベント新規作成、編集、削除ページ
    path: '/S05002004',
    name: 'S05002004',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002004Page.vue')
  },
  {
    // 店舗デイリーカレンダーページ
    path: '/S05002005',
    name: 'S05002005',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002005Page.vue')
  },
  {
    // 会員一覧ページ
    path: '/S05002006',
    name: 'S05002006',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002006Page.vue')
  },
  {
    // 会員情報ページ
    path: '/S05002007',
    name: 'S05002007',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002007Page.vue')
  },

  {
    // 会員ランク管理ページ
    path: '/S05002008',
    name: 'S05002008',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002008Page.vue')
  },

  /* {
     // ポイントマスターページ
    path: '/S05002009',
    name: 'S05002009',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002009Page.vue')
  }, */
   
  {
    // ポイント登録確認
   path: '/S05002010',
   name: 'S05002010',
   meta: { requiredLogin: true }, // ログイン必須
   component: () => import('@/views/05/S05002010Page.vue')
 },

 {
  // スタッフ管理
  path: '/S05002011',
  name: 'S05002011',
  meta: { requiredLogin: true }, // ログイン必須
  component: () => import('@/views/05/S05002011Page.vue')
  },

  {
    // スタッフ情報
    path: '/S05002012',
    name: 'S05002012',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002012Page.vue')
  }, 

  {
    // 店舗用ポイント履歴
    path: '/S05002013',
    name: 'S05002013',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002013Page.vue')
  }, 

  {
    // 店舗グループ一覧
    path: '/S05002014',
    name: 'S05002014',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002014Page.vue')
  },
  {
    // 店舗グループ管理
    path: '/S05002015',
    name: 'S05002015',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002015Page.vue')
  },
  {
    // 会員番号バーコード読み取り
    path: '/S05002016',
    name: 'S05002016',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002016Page.vue')
  },
  {
    // 会計
    path: '/S05002017',
    name: 'S05002017',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002017Page.vue')
  },
  {
    // 情報分析
    path: '/S05002018',
    name: 'S05002018',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002018Page.vue')
  },
  {
    // チャット
    path: '/S05002019',
    name: 'S05002019',
    meta: { requiredLogin: true }, // ログイン必須
    component: () => import('@/views/05/S05002019Page.vue')
  },

  // テスト用
  {
    path: '/C000040',
    name: 'C000040',
    component: () => import('@/test/C000040Page.vue')
  },
  {
    path: '/C000210',
    name: 'C000210',
    component: () => import('@/test/C000210Page.vue')
  },
  {
    path: '/C050100',
    name: 'C050100',
    component: () => import('@/test/C050100Page.vue')
  },
  {
    path: '/C050110',
    name: 'C050110',
    component: () => import('@/test/C050110Page.vue')
  },
  {
    path: '/C050120',
    name: 'C050120',
    component: () => import('@/test/C050120Page.vue')
  },
  {
    path: '/C050130',
    name: 'C050130',
    component: () => import('@/test/C050130Page.vue')
  },
  {
    path: '/C050140',
    name: 'C050140',
    component: () => import('@/test/C050140Page.vue')
  },
  {
    path: '/C050150',
    name: 'C050150',
    component: () => import('@/test/C050150Page.vue')
  },
  {
    path: '/C050160',
    name: 'C050160',
    component: () => import('@/test/C050160Page.vue')
  },
  {
    path: '/C050170',
    name: 'C050170',
    component: () => import('@/test/C050170Page.vue')
  }
]

// ルータを作成
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
export default router

/**
 * ログイン必須のエラーを表示する
 */
async function showLoginRequired()
{
  const alert = await alertController.create({
    header: 'Alert',
    message: GFunc.getProperty("msg.2001"),
    buttons: ['OK'],
  });
  await alert.present();
}

/**
 * ログインチェック
 * ログインしてない場合はログイン画面へ遷移する
 */
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiredLogin)) {
    if (!GFunc.isLoggedin()) {
      showLoginRequired();          // エラーメッセージ表示
      next({ name: 'S05002000' }) // ログイン画面は遷移
    } else {
      next()
    }
  } else {
    next() // next() を常に呼び出すようにする
  }
})


